import { usePostPortfolioBuildingSavingsMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioBuildingSavingsMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getBuildingSavingsCreateFormDefaultValues } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormDefaults";
import { getBuildingSavingsCreateFormSchema } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateBuildingSavingsForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioBuildingSavingsMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getBuildingSavingsCreateFormSchema(t),
		defaultValues: getBuildingSavingsCreateFormDefaultValues(),
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddBuildingSavingsSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
